import { render, staticRenderFns } from "./DepositAdd.vue?vue&type=template&id=56a99219"
import script from "./DepositAdd.vue?vue&type=script&lang=js"
export * from "./DepositAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports